import React, { useState, useEffect } from 'react';
import './RejectProposalFeedbackModal.css';

function RejectProposalFeedbackModal({ isOpen, onClose, creator, onReject }) {
  const [feedback, setFeedback] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setFeedback('');
      setIsSubmitting(false);
    }
  }, [isOpen, creator]);

  if (!isOpen) return null;

  const handleSubmit = async () => {
    setIsSubmitting(true);
    try {
      await onReject(feedback?.trim() || '');
      onClose();
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="reject-proposal-feedback-overlay" onClick={onClose}>
      <div className="reject-proposal-feedback-modal" onClick={(e) => e.stopPropagation()}>
        <div className="reject-proposal-feedback-header">
          <h3>Reject Proposal</h3>
          <button type="button" className="reject-proposal-feedback-close" onClick={onClose}>×</button>
        </div>
        <div className="reject-proposal-feedback-body">
          <p>
            {creator?.name ? (
              <>Reject <strong>{creator.name}</strong>? They will not receive an assignment.</>
            ) : (
              'Reject this creator? They will not receive an assignment.'
            )}
          </p>
          <label className="reject-proposal-feedback-label">
            Feedback <span className="optional">(optional – visible to admin)</span>
          </label>
          <textarea
            className="reject-proposal-feedback-textarea"
            placeholder="Add feedback for why this creator was rejected..."
            value={feedback}
            onChange={(e) => setFeedback(e.target.value)}
            rows={4}
          />
        </div>
        <div className="reject-proposal-feedback-footer">
          <button type="button" className="reject-proposal-feedback-cancel" onClick={onClose}>
            Cancel
          </button>
          <button
            type="button"
            className="reject-proposal-feedback-submit"
            onClick={handleSubmit}
            disabled={isSubmitting}
          >
            {isSubmitting ? 'Rejecting…' : 'Reject'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default RejectProposalFeedbackModal;
